import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import { PrepareUrl } from '../../common/helpers/PrepareUrl';
import RouterPaths from '../../constants/RouterPaths';
import { searchInvoices } from '../../invoices/InvoicesActions';
import InvoicesSearch from '../../invoices/search/InvoicesSearch';
import InvoicesTable from '../../invoices/table/InvoicesTable';
import { useQueryString, setQueryString } from '../../common/helpers/queryString';
import { getDealer } from '../DealersActions';

function DealerInvoicesPage() {
  const { dealerId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const query = useQueryString();

  const items = useSelector((state) => state.invoices.get('items'));
  const totalItems = useSelector((state) => state.invoices.get('totalItems'));
  const dealerDetails = useSelector((state) => state.dealers.get('dealerDetails'));

  const [dealerName, setDealerName] = useState(null);
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    organizationId: null,
  });

  // load dealer details for name and confirm org id
  useEffect(() => {
    if (dealerId) {
      dispatch(getDealer(dealerId));
    } else {
      setDealerName(null);
    }
  }, [dispatch, dealerId]);

  // when dealer details are loaded, prefill dealer name and organizationId
  useEffect(() => {
    if (dealerId && dealerDetails?.organization) {
      setDealerName(dealerDetails.organization.officialCompanyName || '');
      setSearchParams((prevState) => ({
        ...prevState,
        organizationId: dealerDetails.organization.id || null,
      }));
    }
  }, [dealerDetails, dealerId]);

  // if dealerId disappears (shouldn't), clear org id
  useEffect(() => {
    if (!dealerId) {
      setSearchParams((prevState) => ({
        ...prevState,
        organizationId: null,
      }));
    }
  }, [dealerId]);

  // search whenever params change
  useEffect(() => {
    dispatch(searchInvoices(searchParams));
  }, [dispatch, searchParams]);

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams((prevState) => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({
      ...prevState,
      offset: value,
    }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Dealers', url: RouterPaths.DEALERS },
    {
      id: 3,
      type: 'link',
      text: 'Edit Dealer',
      url: PrepareUrl(RouterPaths.DEALER_INFORMATION, { id: dealerId }),
    },
    { id: 4, type: 'span', text: 'Invoices' },
  ];

  const dealerOrganizationId = dealerDetails?.organization?.id || null;

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Invoices" />
      <InvoicesSearch
        onSearch={handleSearch}
        dealerName={dealerName}
        dealerOrganizationId={dealerOrganizationId}
      />
      <InvoicesTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
      />
    </Container>
  );
}

export default DealerInvoicesPage;
